import React from 'react'
import {Helmet} from "react-helmet-async";
import './legal-notice.css'
import PrimaryButton from "../components/PrimaryButton";
import Footer from "../components/footer";
import {useTranslation} from "react-i18next";
import LocaleSwitcher from "../i18n/LocaleSwitcher";


const openHomePage = () => window.location.href = "/";

const LegalNotice = () => {
    const {t} = useTranslation();
    const footerMenuItems = [
        <a href={"/"}>
            <span className="Large">{t("footer_menu-home")}</span>
        </a>,
        <a href={"/privacy"}>
            <span className="Large">{t("footer_menu-privacy")}</span>
        </a>
    ]
    return (
        <div className={"page-container"}>
            <Helmet>
                <title>Louis Nguyen</title>
                <meta property="og:title" content="Louis Nguyen"/>
            </Helmet>
            <a href={"/"} className={"logo-nav-link"}>
                <img alt={"Louis Nguyen"} src="/logo.png" className={"logo"}/>
            </a>

            <LocaleSwitcher></LocaleSwitcher>

            <div className={"legal-information"}>
                <h1>{t("legal-notice_heading")}</h1>
                <h4>{t("legal-notice_subheading")}</h4>
                <p>Louis Nguyen</p>
                <p>Hans-Böckler-Str.30</p>
                <p>30926 Seelze</p>
                <p>Deutschland</p>
                <h2>{t("legal-notice_contact")}</h2>
                <p>
                    {t("legal-notice_mail")}: business@louisnguyen.de
                </p>

                <div className={"home-btn"}>
                    <PrimaryButton button="Home" action={openHomePage}/>
                </div>
            </div>

            <Footer footerMenuItems={footerMenuItems}></Footer>
        </div>
    )
}

export default LegalNotice